// セレクタ名の設定
var containerSelector = '._js-collapse__container';
var buttonSelector = '._js-collapse__opener';
var buttonSuffixId = '_tab';
var buttonAppendTargetSelector = '._js-collapse__button-wrapper';
var panelSelector = '._js-collapse__panel'; // アコーディオンの速度

var slideSpeed = 500; // ボタン要素

var $baseButton = $('<button></button>', {
  type: 'button'
}); // 対象要素を取得

var $root = $('._js-collapse');
var $containers = $root.find(containerSelector);
var $panels = $root.find(panelSelector);
/**
 * 関数定義
 */
// 初期化処理

function init() {
  initAttributes();
  initEvents();
} // 初期化処理：初期属性値をセット


function initAttributes() {
  $root.attr('role', 'tablist');
  $containers.each(function (index, elem) {
    var $container = $(elem);
    var $button = $baseButton.clone();
    var $panel = $container.find(panelSelector); // 生成されたボタンを HTML として出力

    $container.find(buttonAppendTargetSelector).append($button);
    var panelId = $panel.attr('id') || $root.attr('id') + '-' + index;
    var buttonId = panelId + buttonSuffixId;
    $button.attr({
      'class': buttonSelector.substr(1),
      'aria-expanded': 'false',
      'aria-selected': 'false',
      'role': 'tab',
      'id': buttonId,
      'aria-controls': panelId
    });
    $panel.attr({
      'aria-hidden': 'true',
      'role': 'tabpanel',
      'id': panelId,
      'aria-labelledby': buttonId
    }).hide(); // aria 属性がセットされると同時に初期非表示に設定
  });
} // 初期化処理：イベントにハンドラを設定


function initEvents() {
  $root.on('focus.collapse', buttonSelector, focusButtonEventHandler);
  $root.on('click.collapse', buttonSelector, clickButtonEventHandler);
} // イベントハンドラ：フォーカス


function focusButtonEventHandler(e) {
  var $button = $(e.target);
  var $buttons = $root.find(buttonSelector); // ボタン全体を初期化

  $buttons.attr('aria-selected', 'false'); // フォーカス対象の属性を変更

  $button.attr('aria-selected', 'true');
} // イベントハンドラ：クリック


function clickButtonEventHandler(e) {
  var $buttons = $root.find(buttonSelector); // クリックされたボタンと、ボタンに連動するパネル要素を取得

  var $button = $(e.target);
  var $panel = $('#' + $button.attr('aria-controls'));
  var $container = $button.closest(containerSelector); // ボタン全体を初期化し、クリック対象の属性を変更

  $buttons.attr('aria-selected', 'false');
  $button.attr('aria-selected', 'true'); // ステートに応じてボタンとパネルの属性値を変更

  if ($button.attr('aria-expanded') === 'false') {
    // 閉じている
    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
    $panel.slideDown(slideSpeed);
  } else {
    // 開いている
    $button.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true');
    $panel.slideUp(slideSpeed);
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
}
/**
 * 初期化処理
 */


init();